import { Dialog, DialogPanel } from '@headlessui/react'
import BookOpenAnimation from '../BookOpenAnimation';
import { useEffect, useState } from 'react';

const isMobileDevice = () => {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
};

const CardPreview = ({ popUp, setPopUp }: any) => {
    const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);

    useEffect(() => {
        if (isMobileDevice()) return;
        const disableContextMenu = (e: MouseEvent) => {
            e.preventDefault();
        };
        document.addEventListener('contextmenu', disableContextMenu);
        return () => {
            document.removeEventListener('contextmenu', disableContextMenu);
        };
    }, []);

    useEffect(() => {
        if (isMobileDevice()) return;
        const blockKeys = (e: any) => {
            if (
                (e.key === 'F12') ||
                (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J' || e.key === 'C')) ||
                (e.key === 'F11') ||
                (e.ctrlKey && e.key === 'p') ||
                (e.metaKey && e.key === 'p') ||
                (e.key === 'F10')
            ) {
                e.preventDefault();
            }
        };
        document.addEventListener('keydown', blockKeys);
        return () => {
            document.removeEventListener('keydown', blockKeys);
        };
    }, []);

    useEffect(() => {
        if (isMobileDevice()) return;
        const checkDevTools = () => {
            const devToolsHeightThreshold = 150;
            const devToolsWidthThreshold = 150;

            const isDevToolsDetected =
                window.outerWidth - window.innerWidth > devToolsWidthThreshold ||
                window.outerHeight - window.innerHeight > devToolsHeightThreshold;

            setIsDevToolsOpen(isDevToolsDetected);
        };
        checkDevTools();
        window.addEventListener('resize', checkDevTools);
        window.addEventListener('orientationchange', checkDevTools);
        
        return () => {
            window.removeEventListener('resize', checkDevTools);
            window.removeEventListener('orientationchange', checkDevTools);
        };
    }, []);

    if (isDevToolsOpen && !isMobileDevice()) {
        return (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                }}
            >
                <h1>Developer Tools Detected! Interaction is disabled.</h1>
            </div>
        );
    }

    return (
        <>
            <Dialog open={popUp?.modal} as="div" className="relative z-10 focus:outline-none" onClose={() => setPopUp((prev: any) => ({ ...prev, modal: false }))}>
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto bg-[#0000006b]">
                    <div className="flex min-h-full items-center justify-center p-4 overflow-hidden">
                        <DialogPanel transition className="images_bg overflow-hidden w-full max-w-[800px] rounded-xl backdrop-blur-2xl duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0">
                            <BookOpenAnimation detail={popUp?.cardDetail} />
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default CardPreview